import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService , AlertService} from '../../../../../services/index';
// import * as $ from 'jquery'
import * as _ from "lodash";

import 'datatables.net';
declare var jQuery : any;
declare var $ : any;

import 'datatables.net-bs4';

@Component({
  selector: 'app-client-migrate',
  templateUrl: './client-migrate.component.html',
  styleUrls: ['./client-migrate.component.css']
})
export class ClientMigrateComponent implements OnInit {


clientData  : any = null ;
clienthead : any ={};
clientbody : any ={};
dataTable : any;
clientName : any = localStorage.getItem("clientName");

constructor(private router:Router, private apiService: ApiService ,private alertService: AlertService , private chRef: ChangeDetectorRef) { }


ngOnInit() {
if(this.apiService.clientmigration == null){
	this.router.navigate(['/migration-tool']);
}
else {
this.clientData =  this.apiService.clientmigration;
this.clienthead = this.clientData[0];
this.clientData.splice(0, 1);
this.clientbody = this.clientData

if ( $.fn.DataTable.isDataTable('#data_table') ) {
  $('#data_table').DataTable().destroy();
}
this.chRef.detectChanges();
 const table: any = $('#data_table');

this.dataTable = table.DataTable({
  "order": []
});
// this.dataTable = table.DataTable({"order": [],"columnDefs": [{ "orderable": false, "targets": 6 }]});

}
}


}
